var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.pagesArr.length
    ? _c("div", { staticClass: "pagination" }, [
        _c(
          "a",
          {
            class: [
              "slide-nav nav-first",
              {
                "nav-disabled": _vm.currentPage == 1 || _vm.isLoadMoreDisabled,
              },
            ],
            attrs: {
              href: _vm.getPageLink(_vm.firstPage, _vm.currentPage == 1),
            },
            on: {
              click: function ($event) {
                return _vm.updatePage(_vm.firstPage, $event)
              },
            },
          },
          [_c("span", [_vm._v(_vm._s(_vm.firstPageBtn))])]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            class: [
              "slide-nav nav-left",
              {
                "nav-disabled": _vm.currentPage == 1 || _vm.isLoadMoreDisabled,
              },
            ],
            attrs: {
              href: _vm.getPageLink(_vm.currentPage - 1, _vm.currentPage == 1),
            },
            on: {
              click: function ($event) {
                return _vm.updatePage(_vm.currentPage - 1, $event)
              },
            },
          },
          [_c("span", [_vm._v(_vm._s(_vm.prevPageBtn))])]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pagination-number" },
          _vm._l(_vm.pagesArr, function (p) {
            return _c(
              "a",
              {
                key: "page_" + p.text,
                class: [
                  { active: p.text == _vm.currentPage },
                  { "nav-disabled": _vm.isLoadMoreDisabled },
                ],
                attrs: { href: _vm.getPageLink(p.text) },
                on: {
                  click: function ($event) {
                    return _vm.updatePage(p.text, $event)
                  },
                },
              },
              [_vm._v(_vm._s(p.text))]
            )
          }),
          0
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            class: [
              "slide-nav nav-right",
              {
                "nav-disabled":
                  _vm.currentPage == _vm.lastPage || _vm.isLoadMoreDisabled,
              },
            ],
            attrs: {
              href: _vm.getPageLink(
                _vm.currentPage + 1,
                _vm.currentPage == _vm.lastPage
              ),
            },
            on: {
              click: function ($event) {
                return _vm.updatePage(_vm.currentPage + 1, $event)
              },
            },
          },
          [_c("span", [_vm._v(_vm._s(_vm.nextPageBtn))])]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            class: [
              "slide-nav nav-last",
              {
                "nav-disabled":
                  _vm.currentPage == _vm.lastPage || _vm.isLoadMoreDisabled,
              },
            ],
            attrs: {
              href: _vm.getPageLink(
                _vm.lastPage,
                _vm.currentPage == _vm.lastPage
              ),
            },
            on: {
              click: function ($event) {
                return _vm.updatePage(_vm.lastPage, $event)
              },
            },
          },
          [_c("span", [_vm._v(_vm._s(_vm.lastPageBtn))])]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }